import { useLabel } from '~hooks/useLabels';

export type StatusChipProps = {
  label: string;
  highlight?: boolean;
};

export function StatusChip({ label: labelId, highlight = false }: StatusChipProps) {
  const label = useLabel(labelId);
  return (
    <span
      className={`relative flex items-center border border-solid bg-gray px-2 mx-1 rounded-full ${
        highlight ? 'border-edit' : 'border-silver'
      }`}
    >
      <span className="block whitespace-nowrap text-xs text-darkgray leading-0">{label}</span>
    </span>
  );
}
